'use es6';
/*
 * Adds ESLint JS linting to CodeMirror instance.
 */

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactUtilsPropTypes from 'react-utils/CustomPropTypes';
import getComponentName from 'react-utils/getComponentName';
import { WORKER_URL } from 'react-codemirror/constant/ESLint';
import LintFactory from 'react-codemirror/decorator/_internal/components/LintFactory';
import { isBoolean } from '../util/miniUnderscore.js';
const DEFAULT_EXTEND_ESLINT_RECOMMENDED = false;
export default function eslint(opts) {
  opts = opts || {};
  const defaultLintOptions = {
    config: opts.config ? Object.assign({}, opts.config) : {},
    options: opts.options ? Object.assign({}, opts.options) : {},
    extendESLintRecommended: isBoolean(opts.extendESLintRecommended) ? opts.extendESLintRecommended : DEFAULT_EXTEND_ESLINT_RECOMMENDED
  };
  return function withEsLint(CodemirrorComponent) {
    const Lint = LintFactory(CodemirrorComponent, WORKER_URL, defaultLintOptions);

    class WithEsLint extends Component {
      createOptions(props) {
        const {
          esLintConfig,
          esLintOptions,
          extendESLintRecommended
        } = props;
        const options = {
          config: esLintConfig || defaultLintOptions.config,
          options: esLintOptions || defaultLintOptions.options,
          extendESLintRecommended: isBoolean(extendESLintRecommended) ? extendESLintRecommended : defaultLintOptions.extendESLintRecommended
        };

        if (this.__options && this.__options.config === options.config && this.__options.options === options.options && this.__options.extendESLintRecommended === options.extendESLintRecommended) {
          return this.__options;
        }

        this.__options = options;
        return this.__options;
      }

      render() {
        const _this$props = this.props,
              {
          enableEsLint,
          onEsLint,
          esLintDebouncePeriod
        } = _this$props,
              filteredProps = _objectWithoutPropertiesLoose(_this$props, ["enableEsLint", "onEsLint", "esLintConfig", "esLintOptions", "esLintDebouncePeriod"]);

        return /*#__PURE__*/_jsx(Lint, Object.assign({}, filteredProps, {
          enableLint: enableEsLint,
          onLint: onEsLint,
          lintDebouncePeriod: esLintDebouncePeriod,
          lintOptions: this.createOptions(this.props)
        }));
      }

    }
    /*
     * Statics
     */


    WithEsLint.propTypes = {
      /**
       * Enables/Disables validation
       */
      enableEsLint: PropTypes.bool,

      /**
       * Optional callback fired on response from API.
       * (annotations, apiResponse) => { }
       */
      onEsLint: PropTypes.func,
      // // TODO
      // onEsLintReady: PropTypes.func,

      /**
       * Optional overrides to ESLint's config.
       * The second parameter passed to Linter#verify()
       * @see {@link https://eslint.org/docs/developer-guide/nodejs-api#linterverify}
       */
      esLintConfig: PropTypes.object,

      /**
       * Optional overrides to ESLint's options.
       * The third parameter passed to Linter#verify()
       * @see {@link https://eslint.org/docs/developer-guide/nodejs-api#linterverify}
       */
      esLintOptions: PropTypes.object,

      /**
       * Effectively the same as using a configuration file with
       * the `"extends": "eslint:recommended"` settings.
       */
      extendESLintRecommended: PropTypes.bool,

      /**
       * Debounce period to lint after changes to document are made.
       */
      esLintDebouncePeriod: ReactUtilsPropTypes.uint32
    };
    WithEsLint.displayName = `WithEsLint(${getComponentName(CodemirrorComponent, 'CodemirrorComponent')})`;
    return WithEsLint;
  };
}